<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/NJnLT1/tc-custom/9781429936552.jpg?1726444246470" alt="This image is the cover for the book Corpse in the Koryo, The Inspector O Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Corpse in the Koryo, The Inspector O Novels
      </h1>
      <p class="bookDescription body article font2">
        <p><i>Against the backdrop of a totalitarian </i><i>North Korea</i><i>, one man unwillingly uncovers the truth behind series of murders, and wagers his life in the process.</i><br/><br/><i>Sit on a quiet hillside at dawn among the wildflowers; take a picture of a car coming up a deserted highway from the south</i>. Simple orders for Inspector O, until he realizes they have led him far, far off his department's turf and into a maelstrom of betrayal and death. North Korea's leaders are desperate to hunt down and eliminate anyone who knows too much about a series of decades-old kidnappings and murders---and Inspector O discovers too late he has been sent into the chaos.<br/><br/>This is a world where nothing works as it should, where the crimes of the past haunt the present, and where even the shadows are real. A corpse in Pyongyang's main hotel---the Koryo---pulls Inspector O into a confrontation of bad choices between the devils he knows and those he doesn't want to meet. A blue button on the floor of a hotel closet, an ice blue Finnish lake, and desperate efforts by the North Korean leadership set Inspector O on a journey to the edge of a reality he almost can't survive. <br/><br/>Like Philip Kerr's Berlin Noir trilogy and the Inspector Arkady Renko novels, <i>A Corpse in the Koryo</i> introduces another unfamiliar world, a perplexing universe seemingly so alien that the rules are an enigma to the reader and even, sometimes, to Inspector O. Author James Church weaves a story with beautifully spare prose and layered descriptions of a country and a people he knows by heart after decades as an intelligence officer. This is a chilling portrayal that, in the end, leaves us wondering if what at first seemed unknowable may simply be too familiar for comfort.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        James Church
      </h2>
      
      <p class="authorDescription body article"><P>JAMES CHURCH is the pseudonym of a former Western intelligence officer with decades of experience in Asia. He has wandered through Korea for years. No matter what hat he wore, Church says, he ran across Inspector O many times.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Thomas Dunne Books St. Martin’s Minotaur
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2e2c461a